import { render } from "./FormSavingIndicatorComponent.vue?vue&type=template&id=ae0cd7f8&scoped=true&ts=true"
import script from "./FormSavingIndicatorComponent.vue?vue&type=script&lang=ts"
export * from "./FormSavingIndicatorComponent.vue?vue&type=script&lang=ts"

import "./FormSavingIndicatorComponent.vue?vue&type=style&index=0&id=ae0cd7f8&scoped=true&lang=postcss"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae0cd7f8"]])

export default __exports__